/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import {
  reviewProblemDropdown,
  dispatchProblemCode,
  dispatchBottonState,
} from '../Store/actions';
export default (props) => {
  const getProblemCodeDropdown = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.reviewProblemDropdown
  );
  const getProblemCode = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.getProblemCode
  );
  const getDetailDatainTable = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.getDetailData
  );
  const dispatch = useDispatch();
  return (
    <div className='tBillPanel' data-testid='problem-code-select-box'>
      <TextField
        data-testid='problem-code'
        fullWidth
        select
        placeholder=''
        tabIndex={10}
        InputProps={{ inputProps: { tabIndex: 10 } }}
        InputLabelProps={{
          shrink: true,
        }}
        value={getProblemCode ? getProblemCode : props.cellInfo.value}
        disabled={
          getDetailDatainTable?.formValue?.completeIndex ||
          !props.isEnablebyRole
        }
        onChange={(e) => {
          dispatch(dispatchBottonState(false));
          dispatch(dispatchProblemCode(e.target.value));
          props.cellInfo.node.setDataValue(
            props.cellInfo.column.colId,
            e.target.value
          );
        }}
      >
        {props.probelemDropDownReview && props.probelemDropDownReview.length > 0
          ? props.probelemDropDownReview.map((item) => {
              return (
                <MenuItem
                  key={item.codeValueID && item.codeValueID.codeValue}
                  value={item.codeValueID && item.codeValueID.codeValue}
                >
                  {item.codeValueID.codeValue} {'|'} {item.shortDescription}
                </MenuItem>
              );
            })
          : null}
      </TextField>
    </div>
  );
};
